import React, { useContext } from 'react';
import { i18nContext } from '@/components/pages/assessments/context/i18n.context';
import { displayContext } from '@/components/pages/assessments/context/display.context';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

function AssessmentHelperNote({ note, title }) {
  const { xt } = useContext(i18nContext);
  const { css } = useContext(displayContext);

  if (!note || !note.trim()) return null;

  return (
    <Row className={`${css('helper-note')}`}>
      <Col className={`${css('assessment-column-padding')}`}>
        {title && <h5 className={css('helper-note-title')}>{xt(title)}:</h5>}
        <div className={css('helper-note-content')} dangerouslySetInnerHTML={{ __html: note }}></div>
      </Col>
    </Row>
  );
}

export default AssessmentHelperNote;
